import { CardElement } from '@stripe/react-stripe-js'
import { Stripe, StripeCardElement, StripeElements } from '@stripe/stripe-js'
import { GetSavedPaymentInfoQuery } from '@/types/codegen-federation'

export type PaymentMethod = {
  brand?: string | null
  stripeToken?: string
  errorMessage?: string
}

interface getPaymentMethodProps extends getStripePaymentMethodProps {
  savedPaymentInfo?: GetSavedPaymentInfoQuery['paymentInfo']
}

export const getPaymentMethod = async ({
  savedPaymentInfo,
  stripe,
  elements,
  name,
}: getPaymentMethodProps): Promise<PaymentMethod> => {
  let result: PaymentMethod

  if (savedPaymentInfo) {
    result = {
      brand: savedPaymentInfo.brand,
    }
  } else {
    const paymentMethod = await getStripePaymentMethod({ stripe, elements, name })

    result = {
      brand: paymentMethod?.token?.card?.brand,
      stripeToken: paymentMethod?.token?.id,
      errorMessage: paymentMethod?.error?.message,
    }
  }

  return result
}

interface getStripePaymentMethodProps {
  stripe: Stripe | null
  elements: StripeElements | null
  name: string
}

export const getStripePaymentMethod = async ({ stripe, elements, name }: getStripePaymentMethodProps) => {
  if (!stripe || !elements) return
  const cardElement = elements.getElement(CardElement) as unknown as StripeCardElement

  return await stripe.createToken(cardElement, {
    name: name.trim(),
  })
}
